<rt-empty-state
  [title]="emptyStateConfig.title"
  [desc]="emptyStateConfig.desc"
  [icon]="emptyStateConfig.iconName"
>
  @if (emptyStateConfig.cta) {
    <rt-button (click)="emptyStateConfig.cta.callback()" variant="primary">{{
      emptyStateConfig.cta.label
    }}</rt-button>
  }
</rt-empty-state>
